import { BEMBlock } from 'helpers/classnames';
import { Image } from 'palette/Image';
import { IImageSplash } from 'palette/ProductCard/types/productData';
import '../styles/ImageSplashes.scss';

interface ImageSplashProps {
    splashes?: IImageSplash[];
    onClick: (splash: IImageSplash) => void;
}

function ImageSplashes({
    splashes = [],
    onClick,
}: ImageSplashProps) {
    const [block, BEMElement] = BEMBlock('palette-image-splashes');

    const handleClick = (splash: IImageSplash) => {
        if (splash.tooltip) {
            onClick(splash);
        }
    };

    return (
        <div className={block}>
            {splashes.map(splash => (
                <Image
                    key={splash.src}
                    alt={splash.alt}
                    className={BEMElement('image', { interactive: !!splash.tooltip })}
                    loading="lazy"
                    src={splash.src}
                    width={34}
                    onClick={() => handleClick(splash)}
                />
            ))}
        </div>
    );
}

export default ImageSplashes;
